module.exports = ".submit-btn {\r\n    margin: 20px 0 0 0 ;\r\n}"